import {
	EffectCoverflow,
	EffectFade,
	Navigation,
	Scrollbar,
	Swiper
} from 'swiper';

import {
	$Elements,
	Breakpoints,
	BrowserEvents,
	Classes,
	TransitionDurations
} from './constants';

Swiper.use([EffectCoverflow, EffectFade, Navigation, Scrollbar]);

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Sections ----------

		$('.wines-slider-section').each(function() {

			const content = $(this).find('.section-descriptions');
			const carousel = this.querySelector('.section-carousel');

			if(carousel && !carousel.swiper) {

				const swiper = new Swiper(carousel, {
					speed:                          TransitionDurations.page,
					observer:                       true,
					loop:                           true,
					slidesPerView:                  'auto',
					preventInteractionOnTransition: true,
					navigation:                     {
						nextEl: carousel.querySelector('.swiper-button-next'),
						prevEl: carousel.querySelector('.swiper-button-prev'),
					},
					on:                             {
						slideChange: (swiper) => {

							const activeSlide = swiper.slides[swiper.activeIndex];
							const description = activeSlide.querySelector('.wine-description');

							if(description) {
								content.find('.wine-description').removeClass(Classes.active);
								content.find('.wine-description[data-description="' + description.dataset.description + '"]').addClass('active');
							}
						}
					}
				});
			}
		});

		$('.rooms-slider-section').each(function() {

			const carousel = this.querySelector('.swiper-container');

			if(carousel && !carousel.swiper) {

				const swiper = new Swiper(carousel, {
					speed:               TransitionDurations.page,
					observer:            true,
					loop:                true,
					slideToClickedSlide: true,
					centeredSlides:      true,
					slidesPerView:       1,
					navigation:          {
						nextEl: carousel.querySelector('.swiper-button-next'),
						prevEl: carousel.querySelector('.swiper-button-prev'),
					},
				});
			}
		});

		$('.posts-slider-section').each(function() {

			const carousel = this.querySelector('.swiper-container');
			const navigation = this.querySelector('.swiper-navigation');

			if(carousel && !carousel.swiper) {

				const swiper = new Swiper(carousel, {
					speed:               TransitionDurations.page,
					observer:            true,
					slideToClickedSlide: true,
					slidesPerView:       'auto',
					navigation:          {
						nextEl: navigation.querySelector('.swiper-button-next'),
						prevEl: navigation.querySelector('.swiper-button-prev'),
					},
				});
			}
		});

		$('.dates-section').each(function() {

			const carousel = this.querySelector('.swiper-container');
			const content = $(this).find('.dates-content');
			const dates = $(this).find('.dates-svg .date');

			if(carousel && !carousel.swiper) {

				const swiper = new Swiper(carousel, {
					direction:     'horizontal',
					slidesPerView: 'auto',
					freeMode:      true,
					mousewheel:    true,
					scrollbar:     {
						el: carousel.querySelector('.swiper-scrollbar'),
					},
				});
			}

			dates.on('mouseenter touchstart', function() {

				const date = this.dataset.date;

				dates.removeClass(Classes.active);
				$(this).addClass(Classes.active);

				content.find('.date').removeClass(Classes.active);
				content.find('.date[data-date="' + date + '"]').addClass(Classes.active);
			});
		});

		$('.etiquettes-section').each(function() {

			const carousel = this.querySelector('.swiper-container');

			if(carousel && !carousel.swiper) {

				const swiper = new Swiper(carousel, {
					speed:               TransitionDurations.page,
					effect:              'coverflow',
					observer:            true,
					loop:                true,
					slideToClickedSlide: true,
					navigation:          {
						nextEl: carousel.querySelector('.swiper-button-next'),
						prevEl: carousel.querySelector('.swiper-button-prev'),
					},
					coverflowEffect:     {
						rotate:       0,
						slideShadows: false,
					},
					slidesPerView:       2,
					breakpoints:         {
						[Breakpoints.sm]: {
							slidesPerView: 3,
						},
						[Breakpoints.md]: {
							slidesPerView: 4,
						},
					},
				});
			}
		});
	});

}(jQuery));
